export default "__VITE_ASSET__D6G__Z7V__"